export default "__VITE_ASSET__BjyydxpV__"